export default __webpack_public_path__ + "static/media/companyLogo.c978a988.svg";